<template>
    <v-parallax id="Hero"
                dark
                src="../assets/Parallax.jpg"
                height="100%">
        <v-layout
                column
                align-center
                justify-center
                class="white--text"
        >
            <img src="../assets/Logo-FFW.png" alt="Vuetify.js" height="220">
            <h1 class="white--text mb-2 display-3 text-center">Fight for win</h1>
            <div class="subheading mb-4 text-center">Deutschsprachiger <img
                   alt="Clash of Clans" src="../assets/ClashofClansLogo.png" height="18.62" width="40.54"/> Kriegsclan</div>
            <v-btn
                    class="mt-12"
                    color="blue lighten-2"
                    dark
                    large
                    @click="$vuetify.goTo('#aboutus',options)"
            >
                Über uns
            </v-btn>
        </v-layout>
    </v-parallax>
</template>
<script>
    export default {
        mounted() {
            document.getElementById('Hero').style.height = '100vh'
        },
        computed: {
            options() {
                return {
                    offset: 55
                }
            },
        }
    }
</script>
